import { Injectable } from '@angular/core';
import { EMPTY, map, of, switchMap } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';

import { MeasurementUnitService } from '../../services/measurement-unit.service';
import { MeasurementUnitsActions } from './measurement-units.actions';
import { Store } from '@ngrx/store';
import { selectMeasurementUnitsState } from './measurement-units.selector';
import { catchError } from 'rxjs/operators';

@Injectable()
export class MeasurementUnitsEffects {
  constructor(private actions$: Actions, private measurementUnitService: MeasurementUnitService, private store: Store) {}

  unitsNeeded$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MeasurementUnitsActions.measurement_units_needed),
        concatLatestFrom(() => this.store.select(selectMeasurementUnitsState)),
        switchMap(([_, currentState]) => {
          if (!currentState.loaded && !currentState.loading) {
            return of(MeasurementUnitsActions.measurement_units_load_start());
          }
          return EMPTY;
        })
      ),
    { dispatch: true }
  );

  loadUnits$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MeasurementUnitsActions.measurement_units_load_start),
        switchMap(() => {
          return this.measurementUnitService.loadMeasurementUnits().pipe(
            map(measurementUnits => {
              return MeasurementUnitsActions.measurement_units_loaded({ measurementUnits });
            }),
            catchError(() => of(MeasurementUnitsActions.measurement_units_loaded({ measurementUnits: {} })))
          );
        })
      ),
    { dispatch: true }
  );
}
